import React, {useEffect, useState} from 'react';
import { BASE_API } from '../../api/Globals';
import { useParams } from "react-router";
import { helpHttp } from '../../helpers/helpHttp';
import { Button } from 'primereact/button';
import { Link } from "react-router-dom";
  

const VerificationUser = () => {
    const [db, setDb] = useState(null); 
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    
    let {q} = useParams();

    let url = `${BASE_API}auth/verification/${q}`;

    useEffect(() => {
        setLoading(true);
        if(q) { 
            helpHttp().get(url).then(res => {
                if(!res.err) {
                    setDb(res.attachments);
                    setError(null);
                } else {
                    setDb(null);
                    setError(res);
                }
                setLoading(false);
            });
        } else {

        }

    }, [url]);

    return (
        <div className="grid">
            <div className="col-12">
                <div className="card">
                    <div className="grid grid-nogutter surface-section text-800">
                        <div className="col-12 md:col-6 p-6 text-center md:text-left flex align-items-center ">
                            <section>
                                <div className="text-6xl text-primary font-bold mb-3">Secretaría de Educación y Cultura del Estado de Sonora</div>
                                <span className="block text-6xl font-bold mb-1">Tu usuario ha sido activado correctamente</span>
                                <p className="mt-0 mb-4 text-700 line-height-3">Ahora ya puedes obtener tu cédula profesional de cualquier nivel; ya sea técnico, técnico superior universitario, licenciatura, maestría o doctorado, de manera digital.</p>

                                <Link to="/login">
                                    <Button label="Ingresar" className="p-button-rounded p-button-outlined"></Button>
                                </Link>
                            </section>
                        </div>
                        <div className="col-12 md:col-6 overflow-hidden">
                            <img src="images/blocks/hero/verificacion-3.jpg" alt="hero-1" className="md:ml-auto block md:h-full" style={{ clipPath: 'polygon(8% 0, 100% 0%, 100% 100%, 0 100%)' }} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default VerificationUser;